import { z } from 'zod/v4';
import { AI_PROCESSING_STATUSES } from '../../constants.js';

export const AiProcessingItemSchema = z.object({
  id: z.string(),
  assetId: z.string(),
  assetType: z.string(),
  assetName: z.string().nullable(),
  status: z.enum([
    AI_PROCESSING_STATUSES.PROCESSING,
    AI_PROCESSING_STATUSES.COMPLETED,
    AI_PROCESSING_STATUSES.FAILED,
  ]),
  percentage: z.number().nullable(),
  startedAt: z.date(),
  completedAt: z.date().nullable(),
  metadata: z.record(z.string(), z.unknown()).nullable(),
  // Ordered per-step progress. Populated only for CAPA audit-AI items
  // (assetType AUDIT); other asset types omit it. Step order + completion come
  // from the durable workflow record, so finished/failed steps stay reliable
  // even after the best-effort Redis sub-step progress expires.
  steps: z
    .array(
      z.object({
        key: z.string(),
        status: z.enum(['PENDING', 'PROCESSING', 'COMPLETED', 'FAILED']),
        percent: z.number(),
        messageKey: z.string().nullable(),
        reviewedAt: z.string().nullable().optional(),
      }),
    )
    .nullable()
    .optional(),
});

export const AiProcessingStatsSchema = z.object({
  processing: z.number(),
  completed: z.number(),
  failed: z.number(),
  total: z.number(),
  percentage: z.number(),
});

export const AiProcessingSummarySchema = z.object({
  stats: AiProcessingStatsSchema,
  items: z.array(AiProcessingItemSchema),
});

export const GetSummaryQuerySchema = z.object({
  sortByStatus: z
    .enum([
      AI_PROCESSING_STATUSES.COMPLETED,
      AI_PROCESSING_STATUSES.PROCESSING,
      AI_PROCESSING_STATUSES.FAILED,
    ])
    .optional(),
});

export type IAiProcessingItem = z.infer<typeof AiProcessingItemSchema>;
export type IAiProcessingStats = z.infer<typeof AiProcessingStatsSchema>;
export type IAiProcessingSummary = z.infer<typeof AiProcessingSummarySchema>;
export type IGetSummaryQuery = z.infer<typeof GetSummaryQuerySchema>;
